import React, {useContext} from 'react';
import {Modal, Button} from 'antd';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {deleteOrder} from "../api";
import {Store} from "../state_store/provider";
import {ORDER} from "../state_store/actionType";
import {Request} from "../utils";

export default function OrderDelete(props) {
    const {open, onClose, onOK, data} = props
    const {state, dispatch} = useContext(Store)
    const onDelete = ()=>{
        const id = data.id
        Request(dispatch, deleteOrder(id), onOK).then(error=>{
            if(!error){
                const order = state.order.filter(res => res.id !== id)
                dispatch({type: ORDER, payload: order})
            }
        })
        // deleteOrder(id).then(res=>{
        //     if (res.result === 0) {
        //         const order = state.order.filter(res => res.id !== id)
        //         dispatch({type: ORDER, payload: order})
        //         onOK()
        //     }
        // })
    }

    return (

        <Modal visible={open}
               footer={null}
               closable={false}
               width={400}
        >
            <div className={"dialog"}>


                <div className={"delete-dialog-body column center"}>
                    <div className={"icon"}>
                        <ExclamationCircleOutlined/>
                    </div>
                    <div className={"title"}>注⽂情報を削除</div>
                    <div className={"subtitle"}>
                        この注⽂情報に関連する情報が失われます。
                    </div>
                    <div className={"subtitle"}>
                        削除してよろしいですか？
                    </div>

                </div>
                <div className={"delete-dialog-footer row center"}>
                    <Button type="primary" style={{backgroundColor:"#606060"}}
                            onClick={onClose}
                    >キャンセル</Button>
                    <Button
                        onClick={onDelete}
                        type="primary" style={{backgroundColor:"#377EF3"}}>削除する</Button>
                </div>
            </div>
        </Modal>
    );
};
